import { useEffect } from "react";

import { setCookie } from "../helpers/cookies";

const useUTMCookies = () => {
  useEffect(() => {
    // Only run if URLSearchParams is available (modern browsers)
    if (typeof URLSearchParams === "undefined") return;

    // If there's no query string, nothing to store
    if (typeof window === "undefined" || !window.location.search) return;

    // Parse query string
    const urlParams = new URLSearchParams(window.location.search);

    // List which UTM fields you want to capture
    const utmFields = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ];

    // We'll expire cookies after 7 days
    const COOKIE_EXPIRATION_DAYS = 7;

    // For each UTM field, if found in the query string, store it in a cookie
    utmFields.forEach((field) => {
      const value = urlParams.get(field);
      if (value) {
        // Last-touch: overwrite if new values appear
        setCookie(
          field,
          value,
          COOKIE_EXPIRATION_DAYS,
          "." + window.location.hostname,
        );
      }
    });
  }, []);
};

export default useUTMCookies;
